const API_BASE = process.env.REACT_APP_API_BASE_URL;

/* =========================================================
   RESPONSE HANDLER
   ========================================================= */

async function parseResponse(response) {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const error = new Error(
      data?.detail || data?.message || "The administrator request failed.",
    );

    error.status = response.status;
    error.data = data;

    throw error;
  }

  return data;
}

/* =========================================================
   ADMIN DASHBOARD
   ========================================================= */

export async function getAdminDashboard({ accessToken }) {
  const response = await fetch(`${API_BASE}/api/admin/dashboard/`, {
    method: "GET",

    headers: {
      Authorization: `Bearer ${accessToken}`,

      Accept: "application/json",
    },
  });

  return parseResponse(response);
}
